import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export type Tone = 'blue' | 'purple' | 'cyan' | 'green' | 'red' | 'amber';

interface Props {
  tone: Tone;
  icon: React.ReactNode;
  title: React.ReactNode;
  chips?: React.ReactNode;
  sub?: React.ReactNode;
  meta?: React.ReactNode;       // counter / time / unread dot / action
  expandable?: boolean;         // shows the chevron and toggles on click
  open?: boolean;
  unread?: boolean;
  muted?: boolean;              // read notification: muted title
  onToggle?: () => void;
  children?: React.ReactNode;   // nested content, aligned with the text column
}

// One row anatomy for the whole feed: icon tile · title + chip · subtitle · meta · chevron
const FeedRow: React.FC<Props> = ({ tone, icon, title, chips, sub, meta, expandable, open, unread, muted, onToggle, children }) => {
  const toggle = (e: React.MouseEvent | React.KeyboardEvent) => {
    // buttons, links and inputs in the row keep their own click
    if ((e.target as HTMLElement).closest('button, a, input, textarea')) return;
    onToggle?.();
  };
  return (
    <div className={`fd-item${open ? ' open' : ''}${unread ? ' unread' : ''}${muted ? ' muted' : ''}`}>
      <div className={`fd-rw${expandable ? ' clk' : ''}`}
        {...(expandable ? {
          role: 'button', tabIndex: 0, 'aria-expanded': !!open, onClick: toggle,
          onKeyDown: (e: React.KeyboardEvent) => { if (e.key === 'Enter' && e.target === e.currentTarget) toggle(e); },
        } : {})}>
        <span className={`fd-ico fd-t-${tone}`}>{icon}</span>
        <div className="fd-mid">
          <div className="fd-t1"><span className="n">{title}</span>{chips}</div>
          {sub != null && <div className="fd-t2">{sub}</div>}
        </div>
        <div className="fd-right">
          {meta}
          {expandable && <span className={`fd-chev${open ? ' on' : ''}`}><ChevronRightIcon /></span>}
        </div>
      </div>
      {open && children && <div className="fd-nest">{children}</div>}
    </div>
  );
};

export default FeedRow;
